






































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import vSelect from "vue-select";
import { getWayfinderSolutions } from "@/services/wayfinder/wayfinderService";
import { WayfidnerSolution, WayfinderProperties } from "@/services/wayfinder/types";
import validate from "@/directives/validate";
import { propertiesValidators } from "@/components/posts/wayfinder/validators";
import { validateForm } from "@/services/validation/validationService";

@Component({
    components: {
        vSelect
    },
    directives: {
        validate
    }
})
export default class WayfinderForm extends Vue {
    @Prop() private properties!: WayfinderProperties;

    localProperties = {} as WayfinderProperties;
    wayfinderSolutions: WayfidnerSolution[] = [];
    validators = propertiesValidators;

    // lifecycle hooks
    mounted() {
        this.localProperties = this.properties;
    }

    created() {
        this.fetchData();
    }

    async fetchData() {
        this.wayfinderSolutions = await getWayfinderSolutions();
    }

    emitData() {
        this.$emit("propertiesUpdated", this.localProperties);
    }
}
